<template>
    <div class="body">
        <div class="title">
<!--            <div class="title-ico" v-if="academyLogo"><img :src="academyLogo" alt="" /></div>-->
            <div class="title-name">{{ academyName }}</div>
            <div class="title-left">用科技打通教学流程！ 用教学成就知识素养！</div>
        </div>
        <div>
        <div class="form">
            <div class="form-work user-info">
                <div v-if='index_show=="true"'>
                    <div class="forml-top">
                        <div>校内管理工作安排</div>

                    </div>
                    <div class="tablework">
                        <el-table :data="accountData" stripe>
                            <el-table-column prop="name" label="姓名" width="180"></el-table-column>
                            <el-table-column prop="job" label="职务" width="180"></el-table-column>
                            <el-table-column prop="content" label="管理内容"></el-table-column>
                            <el-table-column prop="account" label="账号"></el-table-column>
                        </el-table>
                    </div>
                </div>
                <div v-else>
                    <div class="forml-top">
                        <div>管理员信息</div>

                    </div>
                    <div class='user-box'>
                    <div class='userImg'>

                        <img :src='clickinfo[0].user_img ?clickinfo[0].user_img:"https://c.zikaoj.com/1691570181.734912.png" ' width='150' alt=''>
                        <p><b>{{ clickinfo[0].name }}</b></p>
                    </div>
                    <div class='text-i'>
                        <p><span>性别</span>：{{ clickinfo[0].sex==0?'女':'男' }}</p>
                        <p><span>身份证号</span>：{{ clickinfo[0].id_card }}</p>
                        <p><span>民族</span>：{{ clickinfo[0].nation }}</p>
                        <p><span>政治面貌</span>：{{ clickinfo[0].politics }}</p>
                        <p><span>学历</span>：{{ clickinfo[0].level }}</p>
                        <p><span>专业</span>：{{ clickinfo[0].major }}</p>
                        <p><span>职称</span>：{{ clickinfo[0].title }}</p>
                    </div>
                    </div>
                </div>




            </div>
            <div class="form-site">
                <div class="forml-top">
                    <div>函授站点名录</div>

                </div>
                <div class="tablesite">
                    <el-table  v-if='tr == 1' :data="stationData" stripe style="width: 100%">
                        <el-table-column prop="stationName" label="站点名称" width="280"></el-table-column>
                        <el-table-column prop="contactPerson" label="站点联系人" width="180"></el-table-column>
                        <el-table-column prop="regisNum" label="招生人数"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div class="sheet">
            <div class="sheet-number">
                <div class="forml-top">
                    <div>在校生数据统计</div>

                </div>
                <div id="tablenumber" class='tablenumber'>
                    <div id="tablenumber-left" class='tablenumber-left'></div>
                    <div id="tablenumber-right" class='tablenumber-right'>
                        <div class="tablerightdata">
                            <div class="dotIcon" style="background-color: #3377ff"></div>
                            <div class="tablenumber-year">2022年</div>
                            <div class="tablenumber-people">{{this.opinionData[0]}}人</div>
                        </div>
                        <div class="tablerightdata">
                            <div class="dotIcon" style="background-color: #3377ff"></div>
                            <div class="tablenumber-year">2023年</div>
                            <div class="tablenumber-people">{{this.opinionData[1]}}人</div>
                        </div>
                        <div class="tablerightdata">
                            <div class="dotIcon" style="background-color: #3377ff"></div>
                            <div class="tablenumber-year">2024年</div>
                            <div class="tablenumber-people">{{this.opinionData[2]}}人</div>
                        </div>
                        <div class="tablerightdata">
                            <div class="dotIcon" style="background-color: #3377ff"></div>
                            <div class="tablenumber-year">2025年</div>
                            <div class="tablenumber-people">{{this.opinionData[3]}}人</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sheet-admin">
                <div class="forml-top">
                    <div>管理员信息发送</div>
<!--                    <router-link :to="{ path: '/notice' }">查看更多</router-link>-->
                </div>
                <div class="tableadmin">
                    <el-table :data="announceData" stripe style="width: 100%">
                        <el-table-column prop="sendUser" label="发送人" width="180"></el-table-column>
                        <el-table-column prop="title" label="标题" width="380"></el-table-column>
                        <el-table-column prop="sendTime" label="发送时间"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        </div>


        <el-dialog
            title="公告"
            :visible.sync="centerDialogVisible"
            width="60%"
            :close-on-click-modal="false"
            :show-close="false"
            center>

            <h1 style='text-align: center'>{{ platfrom['title'] }}</h1>

            <div v-html='platfrom["content"]'>

            </div>

            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="savePlat">我已知晓</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
import echarts from 'echarts';

export default {
    data() {
        return {
            //左上
            accountData:[],
            stationData:[],
            countNumData:[],
            announceData:[],
            centerDialogVisible:false,
            charts: '',
            // opinionData: [0, 13, 1],
            opinionData: [],
            academyLogo: '',
            academyName: '',
            accountOrg:'',
            countNum:{},
            index_show: "true",
            clickinfo:[],
            ir:0,
            platfrom:[],

        };
    },
    mounted() {
        this.$nextTick(function() {
            this.drawLine('tablenumber-left');
        });
    },
    created() {

        if (this.$route.query.url == undefined){

        }else{
            localStorage.setItem('loginUrl',this.$route.query.url);
        }

        this.getData()
        this.academyLogo = localStorage.getItem('academyLogo');
        this.academyName = localStorage.getItem('academyName');
        this.accountOrg = localStorage.getItem('org');
        this.index_show = localStorage.getItem('index_show');
        this.ir = localStorage.getItem('ir');
        this.getPlatformList()
    },
    methods: {
        getData() {
            this.$get(this.BASEURL + '/index/info/GET').then((res) => {
                if (res.code === 200) {
                    this.accountData = res.data.accountData
                    this.announceData = res.data.announceData
                    this.stationData = res.data.stationData
                    this.countNumData= res.data.countNum
                    this.clickinfo = res.data.chirl_data
                    //折线图
                    this.opinionData= res.data.countNum
                    this.drawLine('tablenumber-left')
                } else {
                    console.log(res.error);
                }
            });
        },
        drawLine(id) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption({
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '0%',
                    y: '6%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: [ '2021', '2022', '2023', '2024'],
                    axisLabel: { color: 'black' }, // x轴字体颜色
                    axisLine: {
                        lineStyle: { color: 'white' } // x轴坐标轴颜色
                    },
                    axisTick: {
                        lineStyle: { color: 'white' } // x轴刻度的颜色
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        //网格线
                        lineStyle: {
                            type: 'solid' //设置网格线类型 dotted：虚线   solid:实线
                        }
                    },
                    axisLabel: { color: 'black' }, // x轴字体颜色
                    axisLine: {
                        lineStyle: { color: 'white' } // x轴坐标轴颜色
                    },
                    axisTick: {
                        lineStyle: { color: 'white' } // x轴刻度的颜色
                    }
                },
                lineStyle: {
                    color: '#409eff'
                },
                itemStyle: {
                    color: '#409eff'
                },
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        data: this.opinionData,
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    { offset: 1, color: '#8EC5FF' },
                                    { offset: 1, color: 'white' }
                                ])
                            }
                        }
                    }
                ]
            });
        },
        // 获取公告信息
        getPlatformList(){
            this.$get(this.BASEURL + '/index/platform/GET').then((res) => {
                if (res.code === 200) {

                    if(res.show == true){
                        this.centerDialogVisible = true
                    }else{
                        this.centerDialogVisible = false
                    }

                    this.platfrom = res.data
                } else {
                    console.log(res.error);
                }
            });
        },
        putPlatform(id){
            let data = {'id': id}
            this.$put(
                this.BASEURL + '/index/platform/GET',
                data
            ).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.msg);
                    this.getPlatformList();
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        savePlat(){
            this.putPlatform(this.platfrom['id'])
        }
    },
    //调用

};
</script>
<style>
.content{
    overflow-y: visible!important;
}
.content-box{
    overflow-x: auto!important;
}
.el-table td,
.el-table th {
    text-align: center;
}
.el-table th {
    font-weight: bolder;
    color: #333333;
    background: #f5f7fa;
}
</style>
<style lang="scss" scoped>
.sub-body {
    color: #409eff;
}

.subbody {
    color: #f56c6c;
}
.body {
    background: #f0f0f0;
    opacity: 1;
    min-width: 1200px;
    .title {
        height: 73px;
        background: #ffffff;
        opacity: 1;
        display: flex;
        margin-top: 8px;
        margin-bottom: 8px;
        margin-right: 8px;

        .title-ico {
            img {
                width: 36px;
                height: 36px;
            }

            margin: auto 10px;
        }

        .title-name {
            margin-left: 16px;
            line-height: 73px;
            height: 25px;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            opacity: 1;
        }

        .title-left {
            height: 73px;
            line-height: 73px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            opacity: 1;
            margin-left: 20px;
        }
    }

    .form {
        display: flex;
        height: 330px;
        .form-work {
            margin: 8px 8px 8px 0px;
            width: 50%;
            min-width: 550px;
            height: 100%;
            background: #ffffff;
            opacity: 1;
            border-radius: 4px;
            .tablework {
                height: 250px;
            }
        }

        .form-site {
            width: 45%;
            min-width: 650px;
            flex-grow: 1;
            height: 100%;
            background: #ffffff;
            opacity: 1;
            border-radius: 4px;
            margin: 8px 0 8px 8px;
            .formr-top {
                display: flex;
                height: 62px;
                background: #ffffff;
                opacity: 1;
                border-radius: 4px 4px 0px 0px;
            }
            .tablesite {
                height: 250px;
            }
        }
    }

    .sheet {
        margin-top: 20px;
        display: flex;
        height: 335px;
        .sheet-number {
            width: 50%;
            min-width: 550px;
            height: 100%;
            background: #ffffff;
            opacity: 1;
            border-radius: 4px;
            margin: 8px 8px 8px 0px;

            .tablenumber {
                height: 263px;
                opacity: 1;
                border-radius: 4px 4px 0px 0px;
                display: flex;

                .tablenumber-left {
                    display: flex;
                    justify-content: center;
                    width: 70%;
                    height: 170px;
                }

                .tablenumber-right {
                    flex-grow: 1;
                    height: 150px;

                    .tablerightdata {
                        display: flex;
                        margin: 10px 0;

                        .dotIcon {
                            width: 5px;
                            height: 5px;
                            border-radius: 50%;
                            margin-top: 9px;
                        }
                        .tablenumber-year {
                            min-width: 56px;
                            height: 22px;
                            font-size: 16px;
                            font-family: PingFang SC;
                            font-weight: 400;
                            line-height: 22px;
                            color: #333333;
                            opacity: 1;
                            margin: 0 15px;
                        }
                        .tablenumber-people {
                            height: 22px;
                            white-space:nowrap;
                            font-size: 16px;
                            font-family: PingFang SC;
                            font-weight: 400;
                            line-height: 22px;
                            color: #333333;
                            opacity: 1;
                        }
                    }
                }
            }
        }

        .sheet-admin {
            flex-grow: 1;
            width: 45%;
            height: 100%;
            min-width: 650px;
            background: #ffffff;
            opacity: 1;
            border-radius: 4px;
            margin: 8px 0 8px 8px;
            .tableadmin {
                height: 263px;
            }
        }
    }

    .forml-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        height: 62px;
        background: #ffffff;
        opacity: 1;
        border-radius: 4px 4px 4px 4px;
        font-weight: bold;
        color: #333333;
        a{
            font-weight: normal;
            color: #409eff;
        }
    }
}
.user-info{
    .user-box{
        display: flex;
        padding-left: 20px;
    }
    .userImg{
        text-align: center;
        line-height: 33px;
        margin-bottom: 20px;
        margin-right: 20px;
    }
    .text-i{

        font-size: 14px;
        justify-content: center;
        align-items: center;
        p{
            padding: 5px;
            color: #333;
        }
        span{
            font-weight: bold;
        }
    }
}
</style>
